<template>
    <div class="public-client-address-step" data-cy="public-client-address-step">
        <div class="address-hero">
            <div class="address-hero__content">
                <span class="address-hero__eyebrow">Endereço do cliente</span>
                <h4 class="address-hero__title">Agora vamos localizar onde o cliente reside</h4>
                <p class="address-hero__text">
                    Comece pelo CEP para preencher os dados principais e revise numero, complemento e referências.
                </p>
            </div>

            <div class="address-hero__status">
                <span class="address-hero__status-icon">
                    <i class="icon-location_city"></i>
                </span>
                <small>Status</small>
                <strong>{{ addressStatusLabel }}</strong>
            </div>
        </div>

        <div class="address-search-card">
            <div class="address-search-card__field">
                <div class="form-group mb-0">
                    <label for="public_client_cep" :class="{'required':requiredClassValidation('address_id')}">CEP</label>
                    <div class="address-input">
                        <i class="icon-search address-input__icon"></i>
                        <input
                            id="public_client_cep"
                            v-model="address.cep"
                            type="text"
                            inputmode="numeric"
                            maxlength="9"
                            class="form-control address-input__control"
                            placeholder="00000-000"
                            data-cy="public-client-address-cep"
                            @change="loadCep(address.cep)"
                            @input="formatCep"
                        >
                    </div>
                    <div style="color: red" v-if="validate.cep"> {{validate.cep}}</div>
                    <small class="form-text text-muted">
                        Informe o CEP para simular a busca do endereço.
                    </small>
                </div>
            </div>

            <div class="address-search-card__actions">
                <button type="button" class="btn btn-primary" data-cy="public-client-address-search">
                    <i class="icon-search"></i>
                    Buscar endereço
                </button>
            </div>
        </div>

        <div class="mb-3">
            <div class="address-form-card">
                <div class="address-form-card__header">
                    <div class="d-flex flex-row">
                    <span class="address-preview-card__icon">
                    <i class="icon-pin_drop"></i>
                </span>
                    <div class="ml-2">
                        <span class="address-form-card__eyebrow">Dados do endereço</span>
                        <h5>Endereço residencial</h5>
                    </div>
                    </div>
                    <span class="address-form-card__badge">Campos principais</span>
                </div>

                <div class="row gutters">
                    <div class="col-lg-8 col-md-12">
                        <div class="form-group">
                            <label for="street" :class="{'required': requiredClassValidation('address_id') || address.cep}">Logradouro</label>
                            <input id="street" :disabled="!address.cep" v-model="address.street" type="text" class="form-control">
                            <div style="color: red" v-if="validate.street"> {{validate.street}}</div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="form-group">
                            <label for="number" :class="{'required':requiredClassValidation('address_id') || address.cep}">Numero</label>
                            <input id="number" :disabled="!address.cep" v-model="address.number" type="text" class="form-control">
                            <div style="color: red" v-if="validate.number"> {{validate.number}}</div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group">
                            <label for="neighborhood" :class="{'required':requiredClassValidation('address_id') || address.cep}">Bairro</label>
                            <input id="neighborhood" :disabled="!address.cep" v-model="address.neighborhood" type="text" class="form-control">
                            <div style="color: red" v-if="validate.neighborhood"> {{validate.neighborhood}}</div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group">
                            <label for="complement">Complemento</label>
                            <input id="complement" :disabled="!address.cep" v-model="address.complement" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-lg-0">
                            <label for="public_client_city" :class="{'required':requiredClassValidation('address_id') || address.cep}">Cidade</label>
                            <input disabled id="public_client_city" v-model="address.cityName" type="text" class="form-control">
                            <div style="color: red" v-if="validate.cityName"> {{validate.cityName}}</div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-lg-0">
                            <label for="public_client_state" :class="{'required':requiredClassValidation('address_id') || address.cep}">UF</label>
                            <input disabled id="public_client_state" v-model="address.stateName" type="text" class="form-control" maxlength="2">
                            <div style="color: red" v-if="validate.stateName"> {{validate.stateName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="address-extra-card">
            <div class="address-extra-card__header">
                <span><i class="icon-info"></i></span>
                <div>
                    <strong>Informações adicionais</strong>
                    <small>Use este espaco para referências que facilitem a localização.</small>
                </div>
            </div>

            <textarea
                v-model="address.description"
                class="form-control"
                rows="3"
                :disabled="!address.cep"
                placeholder="Ex.: portaria 24h, bloco B, proximo a avenida principal..."
            ></textarea>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import City from '../../../services/City';
import AttributesValidationsMixin from '../../../mixins/AttributesValidationsMixin';
import {mapMutations, mapState} from 'vuex';

export default {
    name: "createPublicPersonStepAddress",
    mixins:[AttributesValidationsMixin],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    mounted() {

    },
    data() {
        return {
            fieldsValidate:['cep', 'street', 'number', 'neighborhood', 'cityName', 'stateName'],
            validate:{},
        }
    },
    computed: {
        ...mapState({
            address: (state) => state.publicClient.address,
            attrsPhisical: (state) => state.publicClient.attrsPhisical,
            attrsJuridical: (state) => state.publicClient.attrsJuridical,
            clientPublicType: (state) => state.publicClient.clientPublicType,
        }),
        addressStatusLabel() {
            return this.address.cep?.length >= 9 ? 'Endereço localizado' : 'Aguardando CEP';
        },
    },
    methods: {
        ...mapMutations({
            setAddressPublicClientMutation:'setAddressPublicClientMutation',
        }),
        formatCep() {
            const digits = String(this.address.cep || '').replace(/\D/g, '').slice(0, 8);
            this.address.cep = digits.replace(/^(\d{5})(\d)/, '$1-$2');
        },
        loadCep(cep){
            if (!cep){
                this.setAddressPublicClientMutation({});
                this.address = {};
                this.validate = {};
                return;
            }
            this.$store.commit("changeLoading", true);
            City.listByCepDisp(cep).then(resp => {
                if (!resp.data.erro && resp.data?.id) {
                    this.address.city_id = resp.data.id;
                    this.address.stateName = resp.data.name;
                    this.address.street = resp.data.logradouro;
                    this.address.neighborhood = resp.data.bairro;
                    this.address.cityName = resp.data.localidade;
                    this.address.complement = resp.data.complemento;
                }else {
                    this.toast.error('Cep Inválido');
                    this.address.cep = null;
                }
                this.$store.commit("changeLoading", false);
            }).catch(() => {
                this.toast.error('Cep Inválido');
                this.address.cep = null;
                this.address = {};
                this.$store.commit("changeLoading", false);
                this.msgCep = this.t('GENERAL.MSG.CEP_INVALID');
            });
        },
        validateAddress() {
            if (!this.address.cep && !this.requiredClassValidation('address_id')){
                this.setAddressPublicClientMutation({});
                return true;
            }
            this.fieldsValidate.forEach(i =>{
                this.setVerifyInformedField(i);
            })
            let can_continue = true;
            Object.entries(this.validate).forEach(([index]) =>{
                if (this.validate[index]){
                    can_continue = false;
                }
            })
            this.setAddressPublicClientMutation(this.address);
            return can_continue;
        },
        setVerifyInformedField(index)
        {
            if (!this.address[index]){
                this.validate[index] = 'Campo Obrigatório';
            }else{
                this.validate[index] = null;
            }
        },
    },
}
</script>

<style scoped>
.public-client-address-step {
    color: #243b35;
}

.address-hero {
    align-items: stretch;
    background: linear-gradient(135deg, #0e5e4e 0%, #16886f 54%, #f2fbf8 54%, #ffffff 100%);
    border-radius: 22px;
    box-shadow: 0 18px 44px rgba(14, 94, 78, .16);
    display: flex;
    gap: 20px;
    justify-content: space-between;
    margin-bottom: 16px;
    overflow: hidden;
    padding: 28px;
}

.address-hero__content {
    max-width: 640px;
    position: relative;
    z-index: 1;
}

.address-hero__eyebrow,
.address-form-card__eyebrow {
    color: #55d5b6;
    display: inline-block;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: .12em;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.address-hero__title {
    color: #ffffff;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 10px;
}

.address-hero__text {
    color: rgba(255, 255, 255, .86);
    font-size: 15px;
    line-height: 1.6;
    margin: 0;
}

.address-hero__status,
.address-preview-card,
.address-search-card,
.address-form-card,
.address-extra-card {
    background: #ffffff;
    border: 1px solid #e4eee9;
    border-radius: 20px;
    box-shadow: 0 16px 36px rgba(21, 56, 48, .08);
}

.address-hero__status {
    align-items: flex-start;
    align-self: center;
    background: rgba(255, 255, 255, .92);
    border-color: rgba(255, 255, 255, .7);
    display: flex;
    flex-direction: column;
    min-width: 210px;
    padding: 18px;
}

.address-hero__status-icon,
.address-preview-card__icon,
.address-extra-card__header span {
    align-items: center;
    background: #e8faf5;
    border-radius: 14px;
    color: #0e5e4e;
    display: flex;
    font-size: 22px;
    height: 46px;
    justify-content: center;
    width: 46px;
}

.address-hero__status small,
.address-preview-card small {
    color: #7a8c87;
    font-weight: 700;
    margin-bottom: 4px;
}

.address-hero__status strong {
    color: #173b33;
    font-size: 16px;
}

.address-search-card {
    align-items: flex-end;
    display: grid;
    gap: 18px;
    grid-template-columns: minmax(0, 1fr) auto;
    margin-bottom: 16px;
    padding: 20px;
}

.address-input {
    position: relative;
}

.address-input__icon {
    color: #16886f;
    font-size: 18px;
    left: 17px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
}

.address-input__control {
    border-color: #d9e8e3;
    border-radius: 15px;
    font-size: 18px;
    font-weight: 700;
    height: 56px;
    letter-spacing: .04em;
    padding-left: 48px;
}

.address-search-card__actions {
    display: flex;
    gap: 10px;
}

.address-search-card__actions .btn {
    border-radius: 12px;
    font-weight: 800;
    min-height: 44px;
}


.address-form-card {
    padding: 24px;
}

.address-form-card__header {
    align-items: center;
    border-bottom: 1px solid #e6efeb;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 18px;
}

.address-form-card__eyebrow {
    color: #16886f;
    margin-bottom: 6px;
}

.address-form-card h5,
.address-preview-card h5 {
    color: #173b33;
    font-weight: 800;
    margin-bottom: 4px;
}

.address-form-card__badge,
.address-preview-card__cep {
    background: #e9fbf6;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 12px;
    font-weight: 800;
    padding: 8px 12px;
}

.address-form-card label,
.address-search-card label {
    color: #344f48;
    font-weight: 800;
}

.address-form-card .form-control,
.address-extra-card .form-control {
    border-color: #dce9e4;
    border-radius: 12px;
    min-height: 44px;
}

.address-input__control:focus,
.address-form-card .form-control:focus,
.address-extra-card .form-control:focus {
    border-color: #19a985;
    box-shadow: 0 0 0 .2rem rgba(25, 169, 133, .14);
}

.address-preview-card {
    align-self: start;
    padding: 22px;
}

.address-preview-card p {
    color: #71857f;
    margin-bottom: 6px;
}

.address-preview-card__cep {
    display: inline-block;
    margin-top: 12px;
}

.address-extra-card {
    padding: 20px;
}

.address-extra-card__header {
    align-items: center;
    display: flex;
    gap: 12px;
    margin-bottom: 14px;
}

.address-extra-card__header span {
    flex: 0 0 44px;
    font-size: 20px;
    height: 44px;
    margin-bottom: 0;
    width: 44px;
}

.address-extra-card__header strong {
    color: #173b33;
    display: block;
    font-size: 15px;
    font-weight: 800;
    margin-bottom: 2px;
}

.address-extra-card__header small {
    color: #71857f;
    display: block;
    line-height: 1.4;
}

html.dark-theme .public-client-address-step {
    color: var(--dark-text-soft);
}

html.dark-theme .address-hero {
    background: linear-gradient(135deg, #064e3b 0%, #0f766e 52%, var(--dark-surface-2) 52%, var(--dark-surface) 100%);
    box-shadow: var(--dark-shadow);
}

html.dark-theme .address-hero__status,
html.dark-theme .address-search-card,
html.dark-theme .address-form-card,
html.dark-theme .address-preview-card,
html.dark-theme .address-extra-card {
    background: var(--dark-surface) !important;
    border-color: var(--dark-border) !important;
    box-shadow: var(--dark-shadow) !important;
}

html.dark-theme .address-hero__status {
    background: rgba(17, 24, 39, .92) !important;
}

html.dark-theme .address-hero__status-icon,
html.dark-theme .address-preview-card__icon,
html.dark-theme .address-extra-card__header span {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .address-hero__status strong,
html.dark-theme .address-form-card h5,
html.dark-theme .address-preview-card h5,
html.dark-theme .address-extra-card__header strong {
    color: var(--dark-text) !important;
}

html.dark-theme .address-hero__status small,
html.dark-theme .address-preview-card small,
html.dark-theme .address-preview-card p,
html.dark-theme .address-extra-card__header small,
html.dark-theme .form-text,
html.dark-theme .text-muted {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .address-input__control,
html.dark-theme .address-form-card .form-control,
html.dark-theme .address-extra-card .form-control {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text-soft) !important;
}

html.dark-theme .address-form-card label,
html.dark-theme .address-search-card label {
    color: var(--dark-text-soft) !important;
}

html.dark-theme .address-input__control::placeholder,
html.dark-theme .address-form-card .form-control::placeholder,
html.dark-theme .address-extra-card .form-control::placeholder {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .address-form-card__badge,
html.dark-theme .address-preview-card__cep {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

@media (max-width: 991.98px) {
    .address-hero {
        background: linear-gradient(160deg, #0e5e4e 0%, #16886f 100%);
        flex-direction: column;
    }

    .address-hero__status {
        align-self: stretch;
    }

    .address-search-card,
    .address-content-grid {
        grid-template-columns: 1fr;
    }

    .address-search-card__actions {
        flex-wrap: wrap;
    }
}

@media (max-width: 575.98px) {
    .public-client-address-step {
        margin-left: -6px;
        margin-right: -6px;
    }

    .address-hero,
    .address-search-card,
    .address-form-card,
    .address-preview-card,
    .address-extra-card {
        border-radius: 16px;
        padding: 16px 12px;
    }

    .address-hero {
        gap: 14px;
        margin-bottom: 12px;
    }

    .address-hero__eyebrow,
    .address-form-card__eyebrow {
        font-size: 10px;
        margin-bottom: 8px;
    }

    .address-hero__title {
        font-size: 21px;
        line-height: 1.22;
        margin-bottom: 8px;
    }

    .address-hero__text {
        font-size: 13px;
        line-height: 1.45;
    }

    .address-hero__status {
        align-items: center;
        border-radius: 14px;
        display: grid;
        gap: 4px 10px;
        grid-template-columns: 40px minmax(0, 1fr);
        min-width: 0;
        padding: 12px;
    }

    .address-hero__status-icon {
        grid-row: span 2;
        height: 40px;
        margin-bottom: 0;
        width: 40px;
    }

    .address-hero__status small,
    .address-hero__status strong {
        margin-bottom: 0;
    }

    .address-search-card,
    .address-content-grid {
        gap: 12px;
        margin-bottom: 12px;
    }

    .address-input__control {
        font-size: 16px;
        height: 50px;
    }

    .address-search-card__actions {
        gap: 8px;
    }

    .address-form-card__header,
    .address-extra-card__header {
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 14px;
        padding-bottom: 14px;
    }

    .address-form-card h5,
    .address-preview-card h5 {
        font-size: 17px;
    }

    .address-form-card .row.gutters > [class*="col-"] {
        margin-bottom: 12px;
    }

    .address-form-card .form-group,
    .address-form-card .form-group.mb-lg-0,
    .address-form-card .form-group.mb-0 {
        margin-bottom: 0 !important;
    }

    .address-form-card label,
    .address-search-card label {
        font-size: 12px;
        margin-bottom: 6px;
    }

    .address-form-card .form-control,
    .address-extra-card .form-control {
        border-radius: 11px;
        min-height: 42px;
    }

    .address-preview-card {
        display: grid;
        gap: 2px 12px;
        grid-template-columns: 44px minmax(0, 1fr);
    }

    .address-preview-card__icon {
        grid-row: span 5;
        height: 44px;
        margin-bottom: 0;
        width: 44px;
    }

    .address-preview-card p {
        font-size: 13px;
        margin-bottom: 3px;
    }

    .address-preview-card__cep {
        justify-self: start;
        margin-top: 6px;
        padding: 7px 10px;
    }

    .address-extra-card__header span {
        height: 40px;
        width: 40px;
    }

    .address-search-card__actions,
    .address-search-card__actions .btn {
        width: 100%;
    }
}

@media (max-width: 991.98px) {
    html.dark-theme .address-hero {
        background: linear-gradient(160deg, #064e3b 0%, var(--dark-surface-2) 100%) !important;
    }
}

</style>
